const styles = (theme) => ({
    wrap: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        fontSize: '0.7rem',
        justifyContent: 'space-between',
        width: '100%',
        background: 'white',
        padding: '15px',
        borderRadius: '5px'
      },
      section1: {
        marginBottom: theme.spacing(2),
      },
      root: {
        marginBottom: '10px',
        padding: '3px 0',
        boxShadow: 'none',
        border: '1px solid lightgrey',
        borderRadius: '10px',
        "&:first-child": {
          borderRadius: '10px',
        }
      }
});

export default styles;
